import type { ReactNode } from 'react';

export function Panel({ title, action, children }: { title: string; action?: ReactNode; children: ReactNode }) {
  return (
    <section className="panel">
      <div className="panel-head">
        <h2>{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}

export function Stat({ label, value, sub }: { label: string; value: ReactNode; sub?: ReactNode }) {
  return (
    <div className="card">
      <div className="label">{label}</div>
      <div className="value">{value}</div>
      {sub ? <div className="sub">{sub}</div> : null}
    </div>
  );
}

/**
 * Status colouring is centralised so that "active" means the same green
 * everywhere. Ops staff scan these by colour before they read the words.
 */
const STATUS_TONE: Record<string, 'ok' | 'warn' | 'danger' | 'info' | ''> = {
  active: 'ok',
  registered: 'info',
  idle: 'warn',
  created: '',
  transferred_to_si: '',
  sold_to_si: '',
  received_by_si: '',
  sold_to_client: 'info',
  released: 'warn',
  repaired: 'warn',
  retired: 'danger',
  open: 'warn',
  triaged: 'info',
  awaiting_si: 'warn',
  awaiting_client: 'warn',
  resolved: 'ok',
  closed: '',
  paid: 'ok',
  issued: 'info',
  overdue: 'danger',
  draft: '',
  void: 'danger',
  pending: 'warn',
  in_progress: 'info',
  completed: 'ok',
  paused: 'warn',
  rolled_back: 'danger',
  applied: 'ok',
  failed: 'danger',
};

export function Status({ value }: { value: string | null | undefined }) {
  if (!value) return <span className="badge">unknown</span>;
  const tone = STATUS_TONE[value] ?? '';
  return <span className={`badge ${tone}`}>{value.replace(/_/g, ' ')}</span>;
}

export function ErrorBanner({ error }: { error: unknown }) {
  if (!error) return null;
  const message = error instanceof Error ? error.message : String(error);
  return <div className="error">{message}</div>;
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="empty">{children}</div>;
}

export function Loading() {
  return <div className="empty">Loading…</div>;
}
